<template>
  <div class="user">
    <div class="common-seach-wrap fr clearfix">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="供应商">
          <div class="max-w460" @click="onSupplierChoose">
            <el-input style="width: 240px" readonly v-model="supplierName"
                      placeholder="请选择供应商"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="">
          <el-button type="button" style="margin-left: 0px;"
                     @click.stop="resetSearch">重置
          </el-button>
        </el-form-item>

        <div class="date_section">
          <div class="block mr10">
            <el-date-picker v-model="value1" type="date" value-format="yyyy-MM-dd" placeholder="开始时间">
            </el-date-picker>
          </div>
          <div class="block mr10">
            <el-date-picker v-model="value2" type="date" value-format="yyyy-MM-dd" placeholder="结束时间">
            </el-date-picker>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="success" @click="onProductExport">按商品导出
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="orderId" label="ID" width="90"></el-table-column>
          <el-table-column prop="orderMaster.orderNo" label="订单号" width="170"></el-table-column>
          <el-table-column prop="orderMaster.supplierName" label="供应商" min-width="200px"></el-table-column>
          <el-table-column prop="orderMoney" label="订单结算金额" min-width="100px"></el-table-column>
          <el-table-column prop="realSupplierMoney" label="店铺结算金额" min-width="100px"></el-table-column>
          <!--          <el-table-column prop="realSysMoney" label="平台抽成"></el-table-column>-->
          <el-table-column prop="realPlatRetentionMoney" label="平台留存" min-width="100px"></el-table-column>
          <el-table-column prop="realAgentMoney" label="佣金"></el-table-column>
          <!--          <el-table-column prop="sysMoney" label="平台抽成金额"></el-table-column>-->
          <el-table-column prop="refundMoney" label="退款金额" min-width="100px"></el-table-column>
          <el-table-column prop="createTime" label="结算时间" width="160"></el-table-column>
          <el-table-column prop='settledId' fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="addClick(scope.row)" type="text" size="small">详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <supplier-choose ref="supplierChoose" :storeType="20" @closeDialog="supplierChooseOk"/>
  </div>
</template>

<script>
import SupplierApi from '@/api/cash.js'
import qs from 'qs'
import {getCookie} from '@/utils/base.js'
import SupplierChoose from '../../supplier/supplier/dialog/SupplierChoose'

export default {
  components: {SupplierChoose},
  data () {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      value1: '',
      value2: '',
      shopSupplierId: undefined,
      supplierName: '',
      formInline: {}
    }
  },
  created () {

    /*获取列表*/
    this.getTableList()

  },
  methods: {

    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.getTableList()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },

    /*获取列表*/
    getTableList () {
      let self = this
      let Params = this.formInline
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.shopSupplierId = undefined
      if (this.shopSupplierId) {
        Params.shopSupplierId = this.shopSupplierId
      }
      self.loading = true
      SupplierApi.order(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
          console.log(self.tableData)
        })
        .catch(() => {
          self.loading = false
        })
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.formInline.startDay = this.value1
      this.formInline.endDay = this.value2
      this.getTableList()
    },
    /*打开添加*/
    addClick (row) {
      let self = this
      let params = row.settledId
      self.$router.push({
        path: '/cash/settled/detail',
        query: {
          settledId: params
        }
      })
    },
    onExport: function () {
      let Params = {}
      Params.startDate = this.value1
      Params.endDate = this.value2
      if (this.shopSupplierId) {
        Params.shopSupplierId = this.shopSupplierId
      }
      Params.token = getCookie('token')
      window.location.href = process.env.BASE_API + 'shop/cash/settled/export?' + qs.stringify(Params)
    },

    onProductExport: function () {
      let Params = {}
      Params.startDate = this.value1
      Params.endDate = this.value2
      if (this.shopSupplierId) {
        Params.shopSupplierId = this.shopSupplierId
      }
      Params.token = getCookie('token')
      window.location.href = process.env.BASE_API + 'shop/cash/settled/export/byproduct?' + qs.stringify(Params)
    },

    onSupplierChoose () {
      this.$refs.supplierChoose.show()
    },

    supplierChooseOk (e) {
      if (e.type === 'success') {
        this.shopSupplierId = e.params.shopSupplierId || ''
        this.supplierName = e.params.name || ''
      }
    },

    resetSearch () {
      this.shopSupplierId = ''
      this.supplierName = ''
      this.curPage = 1
      this.getTableList()
    }
  }
}
</script>

<style>
.date_section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 18px;
}

.demo-form-inline {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/cash/settled/order.vue